import { render } from "./AlarmsTableCalendarList.vue?vue&type=template&id=e7c80e32&ts=true"
import script from "./AlarmsTableCalendarList.vue?vue&type=script&lang=ts"
export * from "./AlarmsTableCalendarList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__